// src/plugins/global-components.js
import Vue from 'vue'

// 自动注册 components 目录下的所有组件
// const requireComponent = require.context(
//   '../components', // 组件目录的路径
//   false,          // 是否递归查找子目录
//   /\.vue$/        // 匹配文件的正则表达式
// )
const requireComponent = require.context(
  '../components', // 组件目录的路径
  true,          // 是否递归查找子目录
  /index\.vue$/       // 匹配文件的正则表达式
)

export default {
  install(Vue) {
    requireComponent.keys().forEach(fileName => {
      const componentConfig = requireComponent(fileName)
      const componentName = fileName
        .split('/')
        // .slice(-1)[0]
        // .replace(/\.\w+$/, '')
        .slice(-2, -1)[0] // 提取父目录名（如 my-header）
        .replace(/-(\w)/g, (_, c) => c.toUpperCase()); // 转换为 PascalCase


      Vue.component(componentName, componentConfig.default || componentConfig)
    })
  }
}